var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patient_index_column"},[_c('div',{staticClass:"patient_index_column--number"},[_vm._v(_vm._s(_vm.recordNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }